export default "__VITE_ASSET__OEHspRBg__"